import React from 'react'
import { connect } from 'react-redux'
import DocumentErrorModal from './DocumentErrorModal'
import Error from './Error'
import { default as FilterList } from './Filter/List'
import FloorPicker from './FloorPicker'
import { default as FloorHorizontalSelect } from './FloorHorizontal/Select'
import { default as FloorVerticalSelect } from './FloorVertical/Select'
import Sightmap from './Sightmap'
import UnitDetails from './UnitDetails'
import UnitList from './UnitList'
import UnitToolTip from './UnitToolTip'
import {
  setFloorPicker,
  setUnitMap,
  displayDetails,
  displayDocumentErrors,
  displayError,
  displayToolTip,
  filterReset,
  highlightUnit
} from '../actions'

class Document extends React.Component {

  constructor(props) {
    super(props)

    this.handleDetailsClose = this.handleDetailsClose.bind(this)
    this.handleErrorClick = this.handleErrorClick.bind(this)
    this.handleErrorModalDismiss = this.handleErrorModalDismiss.bind(this)
    this.handleFilterReset = this.handleFilterReset.bind(this)
    this.handleUnitMap = this.handleUnitMap.bind(this)
    this.handleUnitClick = this.handleUnitClick.bind(this)
    this.handleUnitOver = this.handleUnitOver.bind(this)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.config !== this.props.config
    || nextProps.document !== this.props.document
    || nextProps.unitmap !== this.props.unitmap
    || nextProps.width !== this.props.width
    || nextProps.height !== this.props.height
    || nextProps.documentErrors !== this.props.documentErrors
    || nextProps.highlightElement !== this.props.highlightElement
    || nextProps.highlightLevel !== this.props.highlightLevel
    || nextProps.highlightHitArea !== this.props.highlightHitArea
    || nextProps.highlightUnit !== this.props.highlightUnit
    || nextProps.displayDetails !== this.props.displayDetails
    || nextProps.displayDocumentErrors !== this.props.displayDocumentErrors
    || nextProps.displayError !== this.props.displayError
    || nextProps.displayToolTip !== this.props.displayToolTip
    || nextProps.filteredUnits !== this.props.filteredUnits
    || nextProps.floorPicker !== this.props.floorPicker
    || nextProps.onChange !== this.props.onChange
    || nextProps.onFilterReset !== this.props.onFilterReset
    || nextProps.filters !== this.props.filters
  }

  handleDetailsClose(event) {
    this.props.dispatch(highlightUnit(event.unit))
    this.props.dispatch(displayDetails(null))
  }

  handleErrorModalDismiss() {
    this.props.dispatch(displayDocumentErrors(false))
  }

  handleErrorClick(event) {
    this.props.dispatch(displayError(event.message))
  }

  handleFloorPicker(event) {
    this.props.dispatch(setFloorPicker(event.floorPicker))
  }

  handleUnitMap(event) {
    this.props.dispatch(setUnitMap(event.unitmap))
  }

  handleUnitClick(event) {
    this.props.dispatch(highlightUnit(event.unit))
    this.props.dispatch(displayDetails(event.unit))
  }

  handleUnitOver(event) {
    if (event.unit !== null && event.x === null && event.y === null) {
      this.props.dispatch(highlightUnit(event.unit))
    } else {
      this.props.dispatch(displayToolTip(event.unit, event.x, event.y))
    }
  }

  handleFilterReset(event) {
    event.preventDefault()
    this.props.dispatch(filterReset())
  }

  render() {
    const {
      dispatch,
      width,
      height,
      documentErrors,
      documentBackgroundColor,
      isTouch,
      highlightElement,
      highlightLevel,
      highlightUnit,
      highlightHitArea,
      displayDetails,
      displayDocumentErrors,
      displayError,
      displayToolTip,
      document,
      config,
      floorPicker,
      filteredUnits,
      units,
      filters,
      sieve,
      unitmap
    } = this.props

    const inputs = config.inputs

    let onlySelectInputs = inputs.filter((input) => {
      if (input.type === 'select') {
        return input
      }
    })

    let floorListInput = inputs.filter((input) => {
      if (input.valueFor === 'floor' && input.type === 'list') {
        return input
      }
    })

    if (floorListInput.length) {
      floorListInput = floorListInput[0]
    }

    // get units filtered, but not by floor
    let currentFilters = filters.toJS()
    let currentFloor = currentFilters.floor
    let neededFilters = Object.assign({}, currentFilters)
    for (let key in neededFilters) {
      let neededFilter = neededFilters[key]
      if (neededFilter === '' || key === 'floor') {
        delete neededFilters[key]
      }
    }

    let filteredUnitsNotByFloor = sieve.sift(units.toJS(), neededFilters)

    /**
     * Handle styling with Javascript
     * If values changes in the CSS/Sass, values here will need to be updated
     * @author Patrick Douglas <pdouglas@engrain.com>
     */
     let mobileWidthBreakPoint = 768
     let appPxWidth = width
     let appPxHeight = height
     let footerPxHeight = 110
     let mainPxHeight = appPxHeight - footerPxHeight
     let mainHeight = 'auto'
     let sightmapHeight = '100%'

     let column1Width, column2Width, column3Width = '100%'

     if (appPxWidth > mobileWidthBreakPoint) {
       sightmapHeight = mainPxHeight

       let column1PxWidth = 250
       let column3PxWidth = 250
       let column2PxWidth = appPxWidth - (column1PxWidth + column3PxWidth)

       if (config.layout === 'highrise') {
         let floorPickerJS = floorPicker.toJS()
         let floorPickerRatio = floorPickerJS.width / floorPickerJS.height

         let floorCount = floorListInput.options.length
         let floorHorizontalItemStyle = {
           width: 44,
           height: 44,
         }

         column1PxWidth = (floorPickerRatio * mainPxHeight) + 15
         column2PxWidth = appPxWidth - (column1PxWidth + column3PxWidth)

         let maxFloorHorizontalItemsPerRow = Math.floor(column2PxWidth / floorHorizontalItemStyle.width)
         let floorHorizontalItemRows = Math.ceil(floorCount / maxFloorHorizontalItemsPerRow)
         let floorHorizontalSelectPadding = 20

         sightmapHeight = (sightmapHeight - floorHorizontalSelectPadding) - (floorHorizontalItemStyle.height * floorHorizontalItemRows)
      }

      column1Width = Math.round(column1PxWidth) + 'px'
      column2Width = Math.round(column2PxWidth) + 'px'
      column3Width = Math.round(column3PxWidth) + 'px'

      mainHeight = mainPxHeight + 'px'
    }

    return (
      <div className="document">
        <div className="main-content" style={{height: mainHeight}}>
          <div className="column column-1" style={{width: column1Width }}>
            { config.layout === 'highrise' ? (
              <FloorPicker
                config={config.highrise.floorpicker}
                currentFloor={currentFloor}
                document={floorPicker}
                handleFloorPicker={this.handleFloorPicker}
                input={floorListInput}
                onChange={this.props.onChange}
                units={filteredUnitsNotByFloor} />
            ) : null }
            { config.layout === 'midrise' ? (
              <FloorVerticalSelect
                config={config.midrise}
                currentFloor={currentFloor}
                direction="desc"
                displayCount={config.unitsDisplayCount !== undefined ? config.unitsDisplayCount : true }
                height={mainHeight.replace('px', '')}
                input={floorListInput}
                onChange={this.props.onChange}
                units={filteredUnitsNotByFloor} />
            ) : null }
          </div>
          <div className="column column-2" style={{width: column2Width}}>
            { config.layout === 'highrise' ? (
              <FloorHorizontalSelect
                currentFloor={currentFloor}
                direction="asc"
                displayCount={config.unitsDisplayCount !== undefined ? config.unitsDisplayCount : true }
                input={floorListInput}
                onChange={this.props.onChange}
                units={filteredUnitsNotByFloor} />
            ) : null }
            <Sightmap
              config={config.unitmap}
              document={document}
              backgroundColor={documentBackgroundColor}
              height={sightmapHeight}
              onUnitMap={this.handleUnitMap}
              onUnitClick={this.handleUnitClick}
              onUnitOver={this.handleUnitOver}
              currentFloor={currentFloor}
              highlightedUnit={highlightUnit}
              units={filteredUnits} />
            {displayToolTip && !isTouch ? (
              <UnitToolTip
                unit={displayToolTip.unit}
                x={displayToolTip.x}
                y={displayToolTip.y}
                onUnitClick={this.handleUnitClick} />
            ) : null}
          </div>
          <div className="column column-3" style={{width: column3Width}}>
            <UnitList
              displayCount={config.unitsDisplayCount !== undefined ? config.unitsDisplayCount : true }
              onUnitClick={this.handleUnitClick}
              onUnitOver={this.handleUnitOver}
              units={filteredUnits} />
            {displayDocumentErrors ? (
              <DocumentErrorModal
                errors={documentErrors}
                onDismiss={this.handleErrorModalDismiss} />
            ) : null}
          </div>
        </div>
        <FilterList
          imagePath={config.imagePath}
          property={config.property}
          filters={currentFilters}
          inputs={onlySelectInputs}
          onChange={this.props.onChange}
          onFilterReset={this.handleFilterReset} />
        {displayDetails ? (
          <UnitDetails
            unit={displayDetails}
            config={config.details}
            onClose={this.handleDetailsClose} />
        ) : null}
        {displayError ? (
          <Error
            message={displayError}
            onErrorClick={this.handleErrorClick} />
        ) : null}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return state.toObject()
}

export default connect(mapStateToProps)(Document)
